module.exports = __webpack_public_path__ + "static/media/front-of-house.0b367b75.jpg";